import { Spinner } from 'react-bootstrap'
import React from 'react'

const LoadingFullScreen = () => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      background: '#fff'
    }}
  >
    <Spinner animation="border" variant="primary" />
  </div>
)

export default LoadingFullScreen
